// Estados homologados de la liga: mismo texto, ícono y clases en todas las
// pantallas (chip .lx-chip--* y renglón .lx-paso.is-*). Estilos en
// src/assets/styles/components/_liga-ui.scss.
import {
  faArrowRight,
  faCheck,
  faClock,
  faLock,
  faRotateRight,
  IconDefinition
} from "@fortawesome/free-solid-svg-icons";

export type EstadoLx = 'listo' | 'revision' | 'corrige' | 'pendiente' | 'bloqueado' | 'activo'

export interface IEstadoLx {
  // Texto del chip.
  texto: string
  // Ícono del chip y del renglón (null = punto, solo «Pendiente»).
  icono: IconDefinition | null
  // Clase del chip: <span class="lx-chip" [ngClass]="e.chip">.
  chip: string
  // Clase del renglón: <button class="lx-paso" [ngClass]="e.paso">.
  paso: string
  // Lectura para lectores de pantalla («Listo», «Lo estamos revisando»…).
  descripcion: string
}

export const ESTADOS_LX: Record<EstadoLx, IEstadoLx> = {
  listo: {texto: 'Listo', icono: faCheck, chip: 'lx-chip--listo', paso: 'is-listo', descripcion: 'Listo'},
  revision: {texto: 'En revisión', icono: faClock, chip: 'lx-chip--revision', paso: 'is-revision', descripcion: 'Lo estamos revisando'},
  corrige: {texto: 'Corrige', icono: faRotateRight, chip: 'lx-chip--corrige', paso: 'is-corrige', descripcion: 'Necesita una corrección'},
  pendiente: {texto: 'Pendiente', icono: null, chip: 'lx-chip--pendiente', paso: 'is-pendiente', descripcion: 'Pendiente'},
  bloqueado: {texto: 'Bloqueado', icono: faLock, chip: 'lx-chip--bloqueado', paso: 'is-bloqueado', descripcion: 'Se habilita más adelante'},
  activo: {texto: 'Te toca', icono: faArrowRight, chip: 'lx-chip--activo', paso: 'is-actual', descripcion: 'Es tu siguiente paso'}
}
